import { render, staticRenderFns } from "./guide_record_cehckin_process.vue?vue&type=template&id=81d43034&scoped=true&lang=pug&"
var script = {}
import style0 from "./guide_record_cehckin_process.vue?vue&type=style&index=0&id=81d43034&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d43034",
  null
  
)

export default component.exports